import { render, staticRenderFns } from "./RestrictedAccess.vue?vue&type=template&id=0e38168f&scoped=true"
import script from "./RestrictedAccess.vue?vue&type=script&lang=js"
export * from "./RestrictedAccess.vue?vue&type=script&lang=js"
import style0 from "./RestrictedAccess.vue?vue&type=style&index=0&id=0e38168f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e38168f",
  null
  
)

export default component.exports